
import './index.less'
import HocDragAndDrop from '../../Hoc/DragAndDrop/index.jsx'
import HocCalculateDistance from '../../Hoc/CalculateDistance'
import { useEffect, useState } from 'react'
/* import SetColor from '../setColor/index.jsx' */
import React from 'react'

export default function CompMain(props) {
  return (<div className='compMain'>
    <ul className='compMain_box'>
      {props.components.map((item, index) => {
        return (<li className='box_item' key={item.id}>
          <div className='item_left'>
            {index !== 0 && <div className='left_delete' onClick={() => {
              props.deleteFlipping(index)
            }}>
              <i className='delete_icon'><svg class='adui-button-leftIcon adui-icon-base' width='18' height='18' viewBox='0 0 18 18' fill='var(--gray-700)' data-interactive='false' data-icon='delete'><path d='M14 5V15C14 15.5523 13.5523 16 13 16H5C4.44772 16 4 15.5523 4 15V5H2.5C2.22386 5 2 4.77614 2 4.5V4C2 3.72386 2.22386 3.5 2.5 3.5H6V2.5C6 2.22386 6.22386 2 6.5 2H11.5C11.7761 2 12 2.22386 12 2.5V3.5H15.5C15.7761 3.5 16 3.72386 16 4V4.5C16 4.77614 15.7761 5 15.5 5H14ZM6.75 6.5V13H8.25V6.5H6.75ZM9.75 6.5V13H11.25V6.5H9.75Z' fill-rule='evenodd'></path></svg></i>
            </div>}

          </div>
          <Comps
            compIfon={item}
            pressItem={props.pressItem}
            pressAndHold={props.pressAndHold}
            move={props.move}
            up={props.up}
            selectItem={props.selectItem}
            deleteItem={props.deleteItem}
            hoistPopup={props.hoistPopup}
            mySetIfon={props.mySetIfon}
            backColor={props.backColor}
          ></Comps>
        </li>)
      })}
    </ul>

  </div>)
}

function Comps(props) {
  const [ifon] = useState({
    compBox: React.createRef(),
    content: React.createRef()
  })

  useEffect(() => {
    props.compIfon.compBox = ifon.compBox.current
    props.compIfon.content = ifon.content.current
  }, [])

  return (<div className='Comps'>
    <div className='Comps_left'></div>
    <div className='Comps_main' style={{
      paddingBottom: isBottom(props.compIfon.comps),
      backgroundColor: props.backColor
    }} ref={ifon.compBox}>
      <div className='conCopm' ref={ifon.content}>
        {props.compIfon.comps.map((item, index) => {
          if (item.name === 'Tips1') {
            return <HocCalculateDistance
              compIfon={item}
              key={item.id}
              isSide={false}
              style={Style(item)}
              selectItem={props.selectItem}
            ><item.comp pressItem={props.pressItem} selectItem={props.selectItem}></item.comp></HocCalculateDistance>
          } else {
            return <HocCalculateDistance
              compIfon={item}
              key={item.id}
              isSide={true}
              deleteItem={props.deleteItem}
              selectItem={props.selectItem}
              style={Style(item)}
            ><HocDragAndDrop pressAndHold={props.pressAndHold} move={props.move} up={props.up} copyComp={item.copyComp} ifon={item} isCut={myIsCut(item)}><item.comp mySetIfon={props.mySetIfon} ifon={item.ifon} selectItem={props.selectItem} compIfon={item} hoistPopup={props.hoistPopup}></item.comp></HocDragAndDrop></HocCalculateDistance>
          }
        })}
      </div>

    </div>
  </div>)
}

function myIsCut(item) {
  if (item.name === 'officialAccount_comp' && item.ifon.isSuspension) {
    return false
  }

  if (item.name === 'button_comp' && item.ifon.isSuspension) {
    return false
  }

  return true
}

function isBottom(comps) {
  for (let i = 0; i < comps.length; i++) {
    if (comps[i].name === 'officialAccount_comp' && comps[i].ifon.isSuspension) {
      return 250
    } else if (comps[i].name === 'button_comp' && comps[i].ifon.isSuspension) {
      return 250
    }
  }

  return 0
}

function Style(item) {
  if (item.name === 'officialAccount_comp' && item.ifon.isSuspension) {
    return {
      position: 'absolute',
      bottom: item.ifon.bottomDistance,
      zIndex: 11
    }
  }

  if (item.name === 'button_comp' && item.ifon.isSuspension) {
    return {
      position: 'absolute',
      bottom: item.ifon.bottomDistance,
      zIndex: 11
    }
  }

  return {}
}
